<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  style="padding-top: 80px"
  
>
<div [formGroup]="formWarehouse"  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
<mat-form-field
*ngIf="false"
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Select Warehouse</mat-label>
              <mat-select
               formControlName="warehouse"
              
              >
                <mat-option *ngFor="let item of ResponseWarehouseNameLocationArray" [value]="item.ID">{{item.Warehouse_Name}}</mat-option>
             
              </mat-select>
            </mat-form-field>
            <mat-form-field
            appearance="fill"
            class="
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
          >
            <mat-label>Select Customer</mat-label>
            <mat-select
             formControlName="customer"
           
            >
              <mat-option *ngFor="let item of PlaceOrderCustomer" [value]="item.key"
                >{{ item.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <button
          mat-raised-button
          color="primary"
        
          (click)="OnSelectTypeReportsGenerated()"
        >
          Search
        </button>
        </div>
          <div class="col-md-12" *ngIf="viewTable">
            <table
              datatable
              [dtOptions]="dtoptions"
              class="table table-hover table-striped table-bordered"
              cellspacing="3"
              style="
                background: #ffffffad;
                color: black;
                font-weight: bold !important;
                width: 100% !important;
              "
              id="tabless"
            >
            <thead>
              <tr>
              
                <th>Quantity Pallets</th>
      <th>Item Number</th>
      <th>Item Description</th>
                <th>Pallets Type</th>
                <th>Quantity Location</th>
                <th>Combined Total</th>
                <th>Available</th>
                <th>Location</th>
                <th>Warehouse Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              
            <tr *ngFor="let item of ArrayDataReport2; let i=index">
              <td>{{item.pallet}}</td>
              <td>{{item.itemNumber}}</td>
              <td>{{item.itemDescription}}</td>
              <td>{{item.type_pallets}}</td>
              <td>{{item.locationQuantity}}</td>
              <td>{{item.combinedtotal}}</td>
              <td>{{item.available}}</td>

              <td>{{item.Location}}</td>
            
              <td>{{item.warehouse_Name}}</td>
              <td>
                <button
                mat-menu-item
                *ngIf="btnRemoveInventory"
                color="danger"
                  style="width: 200px; height: 63px"
                (click)="onRemoveInventory(item.order)"
              >
                Delete order {{item.order}}
              </button>
              </td>
            
            </tr>
            </tbody>
            </table>
          </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>